// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"a93f35fd","958":"63acd4b4"}[chunkId] + ".chunk.css";
};